import { useField } from "formik";
import React from "react";
import { TextInput, Field, FieldLabel, InlineNotification} from '@blueprint/ui';

import { GenericFieldProps } from "./common";

type InputFieldProps = {
    type: string;
    maxLength?: number;
    min?: number;
    onBlur?: () => void;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onInput?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    ariaLabelledBy?: string;
    required?: boolean;
} & GenericFieldProps;

const InputField = ({
    className,
    name,
    label,
    type,
    maxLength,
    min,
    autoFocus,
    onBlur,
    onChange,
    onInput,
    disabled,
    ariaLabelledBy,
    required,
}: InputFieldProps): JSX.Element => {
    const [field, meta, helpers] = useField(name);
    const ariaLabel = ariaLabelledBy ? ariaLabelledBy : `notification-help-${name}`;
    return (
        <Field>
            <FieldLabel marginBottom='6px' htmlFor={name}>{label}</FieldLabel>
            <TextInput
                variant="light.large"
                id={name}
                type={type}
                {...field}
                style={{marginBottom: '20px'}}
                onChange={({value})=>{helpers.setValue(value);}}
                readOnly={disabled}
                maxLength={maxLength}
                invalid={Boolean(meta.error)}
                aria-label={label}
                aria-labelledby={ariaLabel}
                aria-describedby={`notification-help-${name}`}
                required={required}
            />
            {meta.error && (
                <InlineNotification variant="warning" id={`notification-help-${name}`}>{meta.error}</InlineNotification>
            )}
        </Field>
    );
};

export default InputField;
